<template>
  <div>
    <!-- 搜索筛选 -->
    <el-form :model="form" class="user-search" label-width="100px" size="small">
      <el-row>
        <el-col :span="7">
          <el-form-item label="编号">
            <el-input size="small" v-model="form.nongoodCode" placeholder="请输入编号" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="名称">
            <el-input size="small" v-model="form.nongoodName" placeholder="请输入名称" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10" class="text-align-right">
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  props:['form'],
  data() {
    return {

    }
  },
  methods: {
    search() {
      // this.getdata(this.form)
      this.$emit('search',this.form);
    },
  },
}
</script>
<style scoped>
.user-search {
  margin-top: 20px;
}
.normal-half-width{
  width: calc(100% - 132px);
  margin-left: 8px;
}
.el-divider__text{
  padding: 0px 0px;
  font-size: 20px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/basicData/defectiveProduct/list-top.vue